import { Feature, FeatureCollection } from 'geojson'


const Districts: Array<Feature> = [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.69935689823112,
              10.774845500000001
            ]
          },
          properties: {
            "name": "Quan 1",
            "population_in_2019": 142625,
            "density": 18474,
            "area": 7.72
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.752614,
              10.786741
            ]
          },
          properties: {
            "name": "Quan 2",
            "population_in_2019": 180275,
            "density": 3620,
            "area": 49.79
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.68702871036014,
              10.77874315
            ]
          },
          properties: {
            "name": "Quan 3",
            "population_in_2019": 190375,
            "density": 38694,
            "area": 4.92
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.70718436949765,
              10.760783400000001
            ]
          },
          properties: {
            "name": "Quan 4",
            "population_in_2019": 175329,
            "density": 41944,
            "area": 4.18
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.6683065744068,
              10.75568335
            ]
          },
          properties: {
            "name": "Quan 5",
            "population_in_2019": 159073,
            "density": 37253,
            "area": 4.27
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.63910717557408,
              10.745868250000001
            ]
          },
          properties: {
            "name": "Quan 6",
            "population_in_2019": 233561,
            "density": 32711,
            "area": 7.14
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.72965167250335,
              10.7374992
            ]
          },
          properties: {
            "name": "Quan 7",
            "population_in_2019": 360155,
            "density": 10091,
            "area": 35.69
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.62949387003158,
              10.7220335
            ]
          },
          properties: {
            "name": "Quan 8",
            "population_in_2019": 424667,
            "density": 22222,
            "area": 19.11
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.815506,
              10.833398
            ]
          },
          properties: {
            "name": "Quan 9",
            "population_in_2019": 397006,
            "density": 3483,
            "area": 113.97
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.66821543148427,
              10.7726536
            ]
          },
          properties: {
            "name": "Quan 10",
            "population_in_2019": 234819,
            "density": 41052,
            "area": 5.72
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.6475536297906,
              10.7660032
            ]
          },
          properties: {
            "name": "Quan 11",
            "population_in_2019": 209867,
            "density": 40830,
            "area": 5.14
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.66424455306318,
              10.8615373
            ]
          },
          properties: {
            "name": "Quan 12",
            "population_in_2019": 620146,
            "density": 11758,
            "area": 52.74,
            "wards": [
              {
                "name": "An Phu Dong",
                "area": 8.56,
                "population_in_2019": 11333,
                "density": 1324
              },
              {
                "name": "Dong Hung Thuan",
                "area": 2.55,
                "population_in_2019": 33068,
                "density": 12958
              },
              {
                "name": "Hiep Thanh",
                "area": 5.31,
                "population_in_2019": 16172,
                "density": 3046
              },
              {
                "name": "Tan Chanh Hiep",
                "area": 4.22,
                "population_in_2019": 15210,
                "density": 3604
              },
              {
                "name": "Tan Hung Thuan",
                "area": 1.81,
                "population_in_2019": 24829,
                "density": 13712
              },
              {
                "name": "Tan Thoi Hiep",
                "area": 3.3,
                "population_in_2019": 14272,
                "density": 4325
              },
              {
                "name": "Tan Thoi Nhat",
                "area": 3.85,
                "population_in_2019": 21716,
                "density": 5641
              },
              {
                "name": "Thanh Loc",
                "area": 5.71,
                "population_in_2019": 12621,
                "density": 2210
              },
              {
                "name": "Thanh Xuan",
                "area": 9.58,
                "population_in_2019": 12414,
                "density": 1296
              },
              {
                "name": "Thoi An",
                "area": 4.51,
                "population_in_2019": 8979,
                "density": 1991
              },
              {
                "name": "Trung My Tay",
                "area": 2.73,
                "population_in_2019": 17764,
                "density": 6507
              }
            ]
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.7705126929586,
              10.840556849999999
            ]
          },
          properties: {
            "name": "Thu Duc",
            "population_in_2019": 592686,
            "density": 12399,
            "area": 47.80
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.67406562042235,
              10.8352833
            ]
          },
          properties: {
            "name": "Go Vap",
            "population_in_2019": 676899,
            "density": 34308,
            "area": 19.73
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.70404167275316,
              10.812294900000001,
            ]
          },
          properties: {
            "name": "Binh Thanh",
            "population_in_2019": 499164,
            "density": 24021,
            "area": 20.78
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.65227606400094,
              10.8030656
            ]
          },
          properties: {
            "name": "Tan Binh",
            "population_in_2019": 474792,
            "density": 21167,
            "area": 22.43
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.62785362180159,
              10.79159445
            ]
          },
          properties: {
            "name": "Tan Phu",
            "population_in_2019": 485348,
            "density": 30391,
            "area": 15.97
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.6798916250364,
              10.8010732
            ]
          },
          properties: {
            "name": "Phu Nhuan",
            "population_in_2019": 163961,
            "density": 33598,
            "area": 4.88
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.6032702,
              10.7820563
            ]
          },
          properties: {
            "name": "Binh Tan",
            "population_in_2019": 784173,
            "density": 15074,
            "area": 52.02
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.50390949756692,
              11.03655
            ]
          },
          properties: {
            "name": "Cu Chi",
            "population_in_2019": 462047,
            "density": 1062,
            "area": 434.77
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.57635314823773,
              10.878345
            ]
          },
          properties: {
            "name": "Hoc Mon",
            "population_in_2019": 542243,
            "density": 4967,
            "area": 109.17
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.51488582967849,
              10.7500035
            ]
          },
          properties: {
            "name": "Binh Chanh",
            "population_in_2019": 705508,
            "density": 2793,
            "area": 252.56
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.72638246812322,
              10.650967049999998
            ]
          },
          properties: {
            "name": "Nha Be",
            "population_in_2019": 206837,
            "density": 2059,
            "area": 100.43
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              106.8808292445988,
              10.5252371
            ]
          },
          properties: {
            "name": "Can Gio",
            "population_in_2019": 71526,
            "density": 101,
            "area": 704.45
          }
        }
];

const HoChiMinh: FeatureCollection = {
    type: "FeatureCollection",
    features: Districts
}

export { HoChiMinh }
